import template from './template.html';
import blockBase from "../../mixins/blockBase";
import {each} from 'lodash';
import MatchMedia from '../../helpers/matchMedia'

export default {
    name: 'steps',
    template: template,
    mixins: [
        blockBase,
    ],
    methods: {
        setDescGutter() {
            each(this.$refs.desc, (item, key) => {
                let height = item.getBoundingClientRect().height;
                item.style.marginBottom =  -(height / 2) + 'px';
            });
        },
        mediaWrapper() {
            if (new MatchMedia().up('md')) {
                this.setDescGutter();
            }
        }
    },
    mounted() {
        this.mediaWrapper();
        window.addEventListener('resize', ()=> {
            this.mediaWrapper();
        });
    }
};